import { useSelector } from "react-redux"

const useFormFields = () => {
    const { grades } = useSelector(state => state.testTaker)
    const { affiliations, groups } = useSelector(state => state.affiliation)

    const fields = [
        {
            name: 'affiliation',
            component: "autoComplete",
            placeholder: "בית ספר",
            options: affiliations,
            mandatory: true,
        },
        {
            name: "grade",
            component: "autoComplete",
            placeholder: "שכבה",
            options: grades,
            className: "b-group",
            mandatory: true,
        },
        {
            name: "name",
            component: "input",
            placeholder: "מספר כיתה ",
        }
    ]

    return fields
}

export default useFormFields